/**
 * Utility for managing the tab URL parameter.
 *
 * This allows deep linking to specific tabs within a workspace view.
 * The tab parameter is updated without triggering a full page navigation.
 */

export const TAB_PARAM_NAME = 'tab';

/**
 * Gets the current tab parameter value from the URL.
 * @returns The tab parameter value, or null if not present.
 */
export function getTabParam(): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get(TAB_PARAM_NAME);
}
